module.exports = __webpack_public_path__ + "static/media/Profile.1ce0eec1.svg";